export default "__VITE_ASSET__DxGINLCF__"